import { render } from "./GridEvents.vue?vue&type=template&id=31dd4c48&scoped=true"
import script from "./GridEvents.vue?vue&type=script&lang=js"
export * from "./GridEvents.vue?vue&type=script&lang=js"

import "./GridEvents.vue?vue&type=style&index=0&id=31dd4c48&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dd4c48"]])

export default __exports__